module.exports = __webpack_public_path__ + "static/media/alerta-combustible-rojo.6fa814d0.svg";